(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ActivateUserCreated', ActivateUserCreated);

    ActivateUserCreated.$inject = ['$resource'];

    function ActivateUserCreated ($resource) {
        var service = $resource('api/user/confirm-registration-for-created-user', {}, {
            'post': { method: 'POST', params: {}, isArray: false}
        });

        return service;
    }
})();
